import React from 'react'
import {
    List,
    Edit,
    DateField,
    ReferenceField,
    BooleanField,
    SimpleForm,
    TextInput,
    Datagrid,
    TextField,
    NumberField,
    NumberInput,
    BooleanInput,
} from 'react-admin'

export const commonCityEdit = ({ ...props }) => (
    <Edit {...props}>
        <SimpleForm>
            <TextField source="id" />
            <TextInput source="iso" />
            <TextInput source="name" />
            <TextInput source="iso3" />
            <NumberInput source="phonecode" />
        </SimpleForm>
    </Edit>
)

export const commonCityList = (props: any) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <TextField source="name" />
                <ReferenceField source="countryId" reference="common/country">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField source="stateId" reference="common/state">
                    <TextField source="name" />
                </ReferenceField>
                <TextField source="countryCode" />
                <DateField source="stateCode" />
                <TextField source="latitude" />
                <TextField source="longitude" />
            </Datagrid>
        </List>
    )
}
